import { Calc } from '@/themes/utils/types'

export const calc = (exp: string): Calc => {
  return `calc(${exp})` as Calc
}
